import { z } from 'zod';
export const TransactionType = z.enum(['charge', 'refund']);
export const TransactionStatus = z.enum([
    'pending',
    'succeeded',
    'failed',
    'refunded',
]);
